export default "__VITE_ASSET__CeeNrdGP__"